import { FieldWrapper } from '@ngx-formly/core';

import { Component, ViewChild, ViewContainerRef } from '@angular/core';

import { ISnFormFieldGroupWrapperConfig } from '../../interfaces/form-field-group-wrapper-config.interface';
import { ISnFormFieldGroupWrapperTemplateOptions } from '../../interfaces/form-field-group-wrapper-template-options.interface';

@Component({
  selector: 'sn-form-field-group-form-wrapper',
  templateUrl: './form-field-group.wrapper.html',
  styleUrls: ['./form-field-group.wrapper.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class SnFormFieldGroupFormWrapper extends FieldWrapper<ISnFormFieldGroupWrapperConfig> {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true })
  public fieldComponent: ViewContainerRef;

  public defaultOptions: ISnFormFieldGroupWrapperConfig = {
    wrappers: ['form-field-group'],
    fieldGroup: [],
    templateOptions: {
      displayGroupStatus: false,
    },
  };

  get templateOptions(): ISnFormFieldGroupWrapperTemplateOptions {
    return this.field.templateOptions;
  }

  public invalid(): boolean {
    return !!this.field.fieldGroup.find((field) => field.formControl.status === 'INVALID');
  }
}
